import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/app/programs/$programId')({
  component: ProgramDetailPage,
});

function ProgramDetailPage() {
  const { programId } = Route.useParams();

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold text-foreground">Program Details</h1>
      <p className="text-sm text-muted-foreground">Program ID: {programId}</p>
    </div>
  );
}
